<template>
  <div class="assignment-notice">
    <span
      class="assignment-notice__content"
      :style="{ fontSize: normalizedFontSize }"
    >
      <v-icon
        class="assignment-notice__icon"
        :style="{ color: '#E00051', marginRight: '1em' }"
        size="32px"
      >mdi-alert-circle-outline</v-icon>{{ message }}
    </span>
  </div>
</template>

<script>
export default {
  name: "AnytimeConsultationAssignmentNotice",
  props: {
    message: {
      type: String,
      default: ""
    },
    fontSize: {
      type: Number,
      default: 26
    }
  },
  computed: {
    normalizedFontSize() {
      return `${this.fontSize}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.assignment-notice {
  width: 100%;
  margin-top: 6rem;
  margin-bottom: 4rem;

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    color: rgb(224, 0, 81);
    font-weight: 700;
  }

  &__icon {
    flex-shrink: 0;
  }
}
</style>
